import React from 'react';
import PlaceMap from '../PlaceMap';

const PlaceMapContainer = () => {
  return <PlaceMap />;
};

export default PlaceMapContainer;
